import { Team } from '@graphql/generated';
export const getTeamLabel = (team?: Team): string => {
  const hasPaymentMethod =
    team?.subscriptionDetails?.paymentCardLast4 !== '' ||
    team?.subscriptionDetails.paymentCardLast4 !== null ||
    team?.subscriptionDetails.paymentCardLast4 !== undefined;
  const trialDate = team?.subscriptionDetails?.trialEndsAt;

  const now = new Date();
  if (team?.personal) return 'Free Forever'; //personal team (1)

  if (team?.subscriptionDetails?.isSubscriptionCanceled) return 'Cancels';

  if (!team?.subscriptionDetails && !team?.personal) return 'Pending';

  if (team?.subscriptionDetails?.isSubscriptionOnTrial) {
    if (trialDate && new Date(trialDate) < now) {
      if (hasPaymentMethod)
        return 'Renews'; // trail ends and has payment method (4)
      else if (!hasPaymentMethod) return 'Expired'; // trial ends and no payment method (3)
    } else if (trialDate && new Date(trialDate) >= now) {
      if (hasPaymentMethod) return 'Renews';
      else return 'Expires';
    }
  }
  if (team?.subscriptionDetails?.isSubscriptionActive) {
    if (hasPaymentMethod && team?.subscriptionDetails?.isSubscriptionCanceled)
      return 'Expires'; // user is being billed but has canceled subscription (2)
    if (hasPaymentMethod) return 'Renews'; // user is being billed (1)
    if (
      team?.subscriptionDetails?.isSubscriptionCanceled ||
      (team?.subscriptionDetails?.subscriptionStatus !== 'canceled' &&
        !hasPaymentMethod)
    )
      return 'Expired'; // plan expired and no payment method (3)
  }

  if (
    team?.subscriptionDetails?.isSubscriptionCanceled &&
    !team?.subscriptionDetails?.isSubscriptionOnTrial &&
    !team?.subscriptionDetails?.isSubscriptionActive
  )
    return 'Expired'; // canceled subscription
  return 'Free Forever';
};
